import { Card, Col, DatePicker, Empty, Row, Table } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { DateRange } from '../../types/base';
import { GCheckInActivityJoinedRecordWithStatus, MarketingActivity } from '../../types/marketingActivity';

export const USER_CHECKIN_JOINED_RECORDS_QUERY = gql`
  query GetUserCheckInRecords($ids: [ID]) {
    users(ids: $ids) {
      checkInActivityJoinedRecords {
        quantity
        sourceId
        status
        userId
        createdAt
        activityId
      }
    }
  }
`;

interface Props {
  userId: number;
  marketingActivityFilterOptions: MarketingActivity[];
}

interface State {
  checkInDateRange: DateRange;
}

export class CheckInRecords extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      checkInDateRange: {
        from: moment().subtract(6, 'days').toDate(),
        to: new Date(),
      },
    };
  }

  getCheckInList(checkInRecords: GCheckInActivityJoinedRecordWithStatus[], loading: boolean) {
    const { checkInDateRange } = this.state;
    const { marketingActivityFilterOptions } = this.props;
    const from = moment(checkInDateRange.from);
    const to = moment(checkInDateRange.to);
    const checkInActivityJoinedRecordsInDateRange = checkInRecords.filter(checkInRecord =>
      moment(checkInRecord.createdAt).isBetween(from, to),
    );
    return (
      <Table<GCheckInActivityJoinedRecordWithStatus>
        columns={[
          {
            title: '日期',
            key: 'date',
            render: record => moment(record && record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            title: '积分活动',
            key: 'from',
            render: record => {
              const marketingActivity = marketingActivityFilterOptions.find(
                marketingActivity => marketingActivity.id === record.activityId,
              );
              return (marketingActivity && marketingActivity.name) || '';
            },
          },
          {
            title: '积分数量',
            key: 'quantity',
            render: record => (record && record.quantity) || 0,
          },
          {
            title: '积分状态',
            key: 'status',
            render: () => '已发放',
          },
        ]}
        loading={loading}
        dataSource={checkInActivityJoinedRecordsInDateRange}
        rowKey={record => `${record.createdAt}`}
        pagination={false}
      />
    );
  }

  getcheckInActivityJoinedPoint(checkInRecords: GCheckInActivityJoinedRecordWithStatus[]) {
    let totalPoint = 0;
    checkInRecords.map(record => {
      totalPoint += Number(record.quantity);
    });
    return totalPoint;
  }
  render() {
    const { userId, marketingActivityFilterOptions } = this.props;
    const { checkInDateRange } = this.state;
    const ids = [Number(userId)];

    if (!marketingActivityFilterOptions.length) {
      return null;
    }
    return (
      <Query query={USER_CHECKIN_JOINED_RECORDS_QUERY} variables={{ ids }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = data.users || {};
          const checkInActivityJoinedRecords = (user && user.checkInActivityJoinedRecords) || [];
          return (
            <div>
              <Card bordered={false}>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    累计积分
                  </Col>
                  <Col span={7}>{this.getcheckInActivityJoinedPoint(checkInActivityJoinedRecords)}</Col>
                </Row>
                <Row gutter={24} style={{ marginTop: 10 }}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    筛选时间
                  </Col>
                  <Col span={19}>
                    <DatePicker.RangePicker
                      value={[moment(checkInDateRange.from), moment(checkInDateRange.to)]}
                      ranges={{
                        今天: [moment(), moment()],
                        本周: [moment().startOf('week'), moment().endOf('week')],
                        上周: [
                          moment().startOf('week').subtract(1, 'week'),
                          moment().endOf('week').subtract(1, 'week'),
                        ],
                      }}
                      onChange={dates =>
                        this.setState({
                          checkInDateRange: {
                            from: moment(dates[0]).startOf('day').toDate(),
                            to: moment(dates[1]).endOf('day').toDate(),
                          },
                        })
                      }
                    />
                  </Col>
                </Row>
              </Card>
              {this.getCheckInList(checkInActivityJoinedRecords, loading)}
            </div>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/CheckInRecords.tsx